import styled from "@emotion/styled";
import { ChangeEvent, FormEvent, useState } from "react";
import theme from "../../theme";
import { ClickBtnParams } from "./contactRecordModal";
import Calendars from "../calendars";
import { SearchForm } from "../common/SearchForm";

export interface SubHeaderProps {
  onClickBtn: ({ fakeStart, fakeEnd, input }: ClickBtnParams) => void;
}

const SubHeader: React.FC<SubHeaderProps> = (props) => {
  const { onClickBtn } = props;
  const [fakeEndDate, setFakeEndDate] = useState<Date | null>(new Date());
  const [fakeStartDate, setFakeStartDate] = useState<Date | null>(
    new Date()
  );
  const [input, setInput] = useState("");
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInput(event.currentTarget.value);
  };

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onClickBtn({
      fakeStart: fakeStartDate,
      fakeEnd: fakeEndDate,
      input,
    });
  };

  return (
    <Wrapper>
      <Calendars
        startDate={fakeStartDate}
        endDate={fakeEndDate}
        setStartDate={setFakeStartDate}
        setEndDate={setFakeEndDate}
        isSeparate={true}
      />

      <SearchForm
        onSubmit={onSubmit}
        placeholder="이름, 연락처 검색"
        onChange={onChange}
        inputValue={input}
        setInputValue={setInput}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  min-height: 90px;
  min-width: 1005px;
  background: ${theme.color.neutral_50};
  /* box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25); */
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding-left: 30px;
  margin-bottom: 23px;
  gap: 15px;
`;

export default SubHeader;
